<template>
  <form class="needs-validation ml-0" @submit.prevent="update" novalidate>
    <div class="col px-0 pr-lg-3" v-if="horse ? horse.id ? true : false : false">
      <section class="bg-white rounded mb-4 p-3 p-sm-4">
        <div class="d-flex justify-content-between align-items-start">
          <h1 class="h2 mb-3">Horse Profile - Pending</h1>
          <span class="badge badge-info flex-shrink-0" v-if="horse.registration_date">Registered</span>
          <span class="badge alert-warning flex-shrink-0" v-else>Unregistered</span>
        </div>
        <div role="alert" class="alert alert-warning" v-if="errors">{{errors}}</div>
        <div class="row">
          <div class="col-12 col-md-6 pr-xl-4 form-group">
            <label for="horseNamePending">Horse Name</label>
            <input type="text" class="form-control" id="horseNamePending" required v-model="horsePending.name">
            <div class="invalid-tooltip">Please include the Horse Name.</div>
          </div>
          <div class="col-12 col-md-6 pl-xl-4 form-group" v-if="Object.keys(ownersList).length > 0">
            <label for="horseOwnerPending">Owner</label>
            <div class="form-inline align-items-start">
              <tags-input element-id="horseOwnerPending"
                v-model="horsePending.owners"
                :existing-tags="ownersList"
                :onlyExistingTags="true"
                :addTagsOnComma="true"
                :typeahead="true"
                :typeaheadStyle="'dropdown'"
                :typeaheadMaxResults="20"
                :typeaheadActivationThreshold="2"
                :limit="1"
                :placeholder="'Start Typing...'"
                :instruction="'Maximum of one owner'"
                ref="tagsInput"></tags-input>
              <div class="invalid-tooltip" :style="isInvalidPending ? 'display: block': ''">Please include the Owner of the horse.</div>
            </div>
          </div>
          <div class="col-12 col-md-6 pl-xl-4 text-center py-2 m-auto" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div class="col-12 col-md-6 pr-xl-4 form-group">
            <div class="row">

              <div class="col-12 col-lg form-group">
                <label for="horseDobPending">Date of Birth</label>
                <input type="date" :class="['form-control form-date', errorStatus === 'validation_error' ? 'is-invalid' : '']" id="horseDobPending" required v-model="horsePending.dob" :placeholder="[isLegacy() ? 'yyyy-mm-dd' : 'dd/mm/yyyy']" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}">
                <div class="invalid-tooltip">Please include the Date of Birth of the horse{{ isLegacy() ? ' in the format yyyy-mm-dd' : ''}}.</div>
              </div>

              <div class="col-12 col-lg-auto form-group">
                <label for="sexPending">Sex</label>
                <select id="sexPending" v-model="horsePending.gender" required name="horseSex" class="form-control">
                  <option default></option>
                  <option value="Mare">Mare</option>
                  <option value="Gelding">Gelding</option>
                  <option value="Stallion">Stallion</option>
                </select>
              </div>

            </div>
          </div>

          <div class="col-12 col-md-6 mb-3 pl-xl-4 form-group">
            <label for="statusPending">Status</label>
            <select class="form-control" id="statusPending" :required="(user === 'Admin' || user === 'SuperAdmin')" :disabled="user === 'Member' || user === 'Secretary'" v-model="horsePending.status.id">
              <option v-for="(status, index) in $store.state.horseStatus" :key="index" :value="status.id">{{status.name}}</option>
            </select>
            <div class="invalid-tooltip">Please include the Status.</div>
          </div>

          <div class="col-12 col-md-6 pr-xl-4 form-group">
            <label for="horseSirePending">Sire <small>(optional)</small></label>
            <div class="not-required">
              <horse-search-select
                element-id="horseSirePending"
                :value="horsePending.sire_id || []"
                @input="v => horsePending.sire_id = v"
              />
            </div>
          </div>

          <div class="col-12 col-md-6 pl-xl-4 form-group">
            <label for="horseDamPending">Dam <small>(optional)</small></label>
            <div class="not-required">
              <horse-search-select
                element-id="horseDamPending"
                :value="horsePending.dam_id || []"
                @input="v => horsePending.dam_id = v"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 pr-xl-4 form-group">
            <label for="ashsPending"><abbr title="Australian Stock Horse Number">ASHS#</abbr> <small>(optional)</small></label>
            <input type="text" class="form-control" id="ashsPending" v-model="horsePending.ashs_number">
          </div>
          <div class="col-12 col-md-6 pl-xl-4 form-group">
            <!-- AQHA# is AQHS# -->
            <label for="aqhsPending"><abbr title="Australian Quarter Horse Number">AQHA#</abbr> <small>(optional)</small></label>
            <input type="text" class="form-control" id="aqhsPending" v-model="horsePending.aqhs_number">
          </div>

          <div class="col-12 d-flex flex-wrap d-lg-none justify-content-end">
            <button :class="['btn btn-block-mob', processing[0] ? 'btn-primary-dark' : 'btn-primary']" @click="handleSubmit">
              {{ !processing[0] ? 'Approve' : '' }}
              <div v-if="processing[0]" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
            </button>
            <button :class="['btn btn-block-mob', processing[1] ? 'btn-primary-dark' : 'btn-outline-primary']" @click.prevent="denyHorse">
              {{ !processing[1] ? 'Deny' : '' }}
              <div v-if="processing[1]" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
            </button>
          </div>
        </div>
      </section>

      <section class="bg-white rounded mb-4 p-3 p-sm-4">
        <div class="d-flex justify-content-between align-items-start">
          <h2 class="mb-3">Horse Profile - Existing</h2>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 pr-xl-4 form-group">
            <label for="horseName">Horse Name</label>
            <input type="text" class="form-control" id="horseName" disabled v-model="horse.name">
          </div>
          <div class="col-12 col-md-6 pl-xl-4 form-group" v-if="Object.keys(ownersList).length > 0">
            <label for="horseOwner">Owner</label>
            <div class="form-inline align-items-start click-events-none not-required">
              <tags-input element-id="horseOwner"
                v-model="horse.owners"
                :existing-tags="ownersList"
                :onlyExistingTags="true"
                :addTagsOnComma="true"
                :typeahead="true"
                :typeaheadStyle="'dropdown'"
                :typeaheadMaxResults="20"
                :typeaheadActivationThreshold="2"
                :limit="1"
                :placeholder="'Start Typing...'"
                :instruction="'Maximum of one owner'"
                ref="tagsInput"></tags-input>
            </div>
          </div>
          <div class="col-12 col-md-6 pl-xl-4 text-center py-2 m-auto" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div class="col-12 col-md-6 pr-xl-4 form-group">
            <div class="row">

              <div class="col-12 col-lg form-group">
                <label for="horseDob">Date of Birth</label>
                <input type="date" class="form-control" id="horseDob" disabled v-model="horse.dob" placeholder="dd/mm/yyyy">
              </div>

              <div class="col-12 col-lg-auto form-group">
                <label>Sex</label>
                <select v-model="horse.gender" disabled name="horseSex" class="form-control">
                  <option default></option>
                  <option value="Mare">Mare</option>
                  <option value="Gelding">Gelding</option>
                  <option value="Stallion">Stallion</option>
                </select>
              </div>

            </div>
          </div>

          <div class="col-12 col-md-6 mb-3 pl-xl-4 form-group">
            <label for="status">Status</label>
            <select class="form-control" id="status" disabled v-model="horse.status.name">
              <option v-for="(status, index) in $store.state.horseStatus" :key="index">{{status.name}}</option>
            </select>
          </div>

          <div class="col-12 col-md-6 pr-xl-4 form-group">
            <label for="horseSire">Sire</label>
            <div class="not-required">
              <horse-search-select element-id="horseSire" :value="horse.sire_id || []" :disabled="true" />
            </div>
          </div>

          <div class="col-12 col-md-6 pl-xl-4 form-group">
            <label for="horseDam">Dam</label>
            <div class="not-required">
              <horse-search-select element-id="horseDam" :value="horse.dam_id || []" :disabled="true" />
            </div>
          </div>
          <div class="col-12 col-md-6 pr-xl-4 form-group">
            <label for="ashs"><abbr title="Australian Stock Horse Number">ASHS#</abbr></label>
            <input type="text" class="form-control" id="ashs" v-model="horse.ashs_number" disabled>
          </div>
          <div class="col-12 col-md-6 pl-xl-4 form-group">
            <!-- AQHA# is AQHS# -->
            <label for="aqhs"><abbr title="Australian Quarter Horse Number">AQHA#</abbr></label>
            <input type="text" class="form-control" id="aqhs" v-model="horse.aqhs_number" disabled>
          </div>
        </div>
      </section>
    </div>

    <desktop-action-bar>
      <button :class="['btn btn-block mb-2', processing[0] ? 'btn-primary-dark' : 'btn-primary']" @click="handleSubmit">
        {{ !processing[0] ? 'Approve' : '' }}
        <div v-if="processing[0]" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
      </button>
      <button :class="['btn btn-block', processing[1] ? 'btn-primary-dark' : 'btn-outline-primary']" @click.prevent="denyHorse">
        {{ !processing[1] ? 'Deny' : '' }}
        <div v-if="processing[1]" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
      </button>
    </desktop-action-bar>

    <!-- use the modal component, pass in the prop -->
    <modal v-if="showModal" @close="showModal = false">
      <div slot="body">
        <div class="alert alert-warning">
          You are about to approve changes to this horse registration, are you sure?
        </div>
        <div class="d-flex justify-content-center">
          <button class="btn btn-outline-primary" @click.prevent="showModal = false">Cancel</button>
          <button class="btn btn-primary ml-2" @click.prevent="updateHorse();showModal = false">Confirm</button>
        </div>
      </div>
    </modal>
  </form>
</template>

<script>
import axios from 'axios'
import HANDLESUBMIT from '@/mixins/formValidation.js'
import LEGACYBROWSERS from '@/mixins/legacyBrowsers.js'
import VoerroTagsInput from '@voerro/vue-tagsinput'
import modal from '@/components/Modal'
import DesktopActionBar from '@/components/DesktopActionBar'
import HorseSearchSelect from '@/components/Horses/HorseSearchSelect'

export default {
  name: 'PendingHorseDetails',
  props: ['horseDetails'],
  mixins: [HANDLESUBMIT, LEGACYBROWSERS],
  components: {
    'tags-input': VoerroTagsInput,
    'horse-search-select': HorseSearchSelect,
    modal,
    DesktopActionBar
  },
  data() {
    return {
      horse: JSON.parse(this.horseDetails.requests[this.horseDetails.requests.length - 1].before),
      horsePending: JSON.parse(this.horseDetails.requests[this.horseDetails.requests.length - 1].after),
      ownersList: {},
      user: localStorage.role,
      showModal: false,
      processing: [false, false],
      errorStatus: '',
      errors: ''
    }
  },
  methods: {
    updateHorse() {
      this.processing.splice(0, 1, true)
      axios.post(`${this.$api}/admin/horse-update`, {
        id: this.horseDetails.id,
        name: this.horsePending.name,
        dob: this.horsePending.dob,
        gender: this.horsePending.gender,
        owners: this.horsePending.owners,
        horse_status_id: this.horsePending.status.id
      }).then((response) => {
        this.processing.splice(0, 1, false)
        // eslint-disable-next-line
        // console.log(response)
        if (response.data.status === 'success') {
          // eslint-disable-next-line
          // console.log('success')
          this.$router.push({ name: 'Horse Updates', params: { success: 'The horse change has been approved.' } })
        } else if (response.data.status === 'validation_error' && response.data.errors.dob) {
          // DoB
          this.errorStatus = 'validation_error'
          this.errors = `Please include the Date of Birth in the format${this.isLegacy() ? ' yyyy-mm-dd' : ' dd/mm/yyyy'}.`
        } else {
          // eslint-disable-next-line
          // console.log('fail')
        }
      }).catch((error) => {
        this.processing.splice(0, 1, false)
        // eslint-disable-next-line
        console.log(error)
      })
    },
    denyHorse() {
      this.processing.splice(1, 1, true)
      axios.post(`${this.$api}/admin/horse-deny-all`, {
        id: this.horseDetails.id
      }).then((response) => {
        this.processing.splice(1, 1, false)
        // eslint-disable-next-line
        // console.log(response)
        if (response.data.status === 'success') {
          // eslint-disable-next-line
          // console.log('success')
          this.$router.push({ name: 'Horse Updates', params: { status: 'The horse change has been denied.' } })
        } else {
          // eslint-disable-next-line
          // console.log('fail')
        }
      }).catch((error) => {
        this.processing.splice(1, 1, false)
        // eslint-disable-next-line
        console.log(error)
      })
    },
    update(event) {
      event.preventDefault()

      if (this.horsePending.owners.length > 0) {
        this.updateHorse()
      }
    }
  },
  computed: {
    isInvalidPending() {
      return this.wasValidated && this.horsePending.owners.length === 0
    },
    isInvalidExisting() {
      return this.wasValidated && this.horse.owners.length === 0
    }
  },
  created() {
    if (!this.horse.status) {
      this.horse.status = { name: null }
    }
    // sire_id / dam_id come from the request JSON as scalars; the pickers work with [id].
    const toIdArray = (obj, key) => {
      if (obj[key]) obj[key] = [obj[key].toString()]
    }
    toIdArray(this.horsePending, 'sire_id')
    toIdArray(this.horsePending, 'dam_id')
    toIdArray(this.horse, 'sire_id')
    toIdArray(this.horse, 'dam_id')
  },
  mounted() {
    if (Object.keys(this.horseDetails).length > 0) {
      axios.get(`${this.$api}/users`).then((response) => {
        if (response.data.status === 'success') {
          this.ownersList = response.data.data.reduce((resultItem, currentArray) => {
            resultItem[currentArray.id] = `${currentArray.member_number}: ${currentArray.first_name} ${currentArray.last_name}`
            return resultItem
          }, {})
          if (typeof this.horse.owners[0] === 'object') {
            this.horse.owners = this.horse.owners[0].id.toString()
          }
          if (typeof this.horsePending.owners[0] === 'object') {
            this.horsePending.owners = this.horsePending.owners[0].id.toString()
          }
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/Admin/Pending/Horse/HorseDetails.vue